import { useNavigate } from "@tanstack/react-router";

import { Button } from "../../ui/button";

// V4.1: Simplified component - delete functionality moved to route-based modal
export const EditCategoryButton = ({
  categoryId,
  menuId,
}: {
  categoryId: string;
  menuId: string;
}) => {
  const navigate = useNavigate();

  // Navigate to route-based edit modal (V4.1: URL-based context tracking)
  const handleEdit = () => {
    void navigate({ to: `/menus/${menuId}/categories/${categoryId}/edit` });
  };

  return (
    <Button
      className="rounded-md"
      onClick={handleEdit}
      type="button"
      variant="outline"
    >
      Edit Category
    </Button>
  );
};
